export const CREATE_AUCTION = '/create-auction'
export const SEARCH_AUCTION = '/search'
export const DASHBOARD = '/dashboard'
export const HOME = '/'
export const AUCTION = '/auction/:auctionId'
